import React, { useState } from "react";
import { Box, Button, FileUpload, Flex, Grid, Text } from "atoms";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import { FormInput } from "molecules";
import { FormSelect } from "molecules/FormInput";
import Table from "molecules/Table";
import MemoDeleteIcon from "assets/icons/DeleteIcon";
import MemoEyeShowIcon from "assets/icons/EyeShow";
// import { Filter } from "molecules/Filter";
import { ConfirmationModal } from "molecules/Modals";

const validationSchema = Yup.object().shape({
  firstname: Yup.string().max(60, "Maximum 60 characters").required("Required"),
  lastname: Yup.string().max(60, "Maximum 60 characters"),
});

const rolesData = [
  {
    id: 0,
    propertyId: "#401",
    market: "Bangalore",
    micromarket: "Whitefield",
    propertyName: "SNN Raj Grandeur",
    date: "07 Oct, 2019",
  },
  {
    id: 1,
    propertyId: "#401",
    market: "Bangalore",
    micromarket: "Whitefield",
    propertyName: "SNN Raj Grandeur",
    date: "07 Oct, 2019",
  },
  {
    id: 2,
    propertyId: "#401",
    market: "Bangalore",
    micromarket: "Whitefield",
    propertyName: "SNN Raj Grandeur",
    date: "07 Oct, 2019",
  },
];
const columns = [
  {
    title: "Property ID",
    field: "propertyId",
    sortKey: "propertyId",
    render: (row) => <>{row.propertyId}</>,
  },
  {
    title: "Market",
    field: "market",
    sortKey: "market",
    render: (row) => <>{row.market}</>,
  },
  {
    title: "Micromarket",
    field: "micromarket",
    sortKey: "micromarket",
    render: (row) => <>{row.micromarket}</>,
  },
  {
    title: "Property Name",
    field: "propertyName",
    sortKey: "propertyName",
    render: (row) => <>{row.propertyName}</>,
  },

  {
    title: "Date",
    field: "date",
    sortKey: "date",
    render: (row) => <Text color="neutral.500">{row.date}</Text>,
  },

  {
    title: "Actions",
    rightAligned: true,
    render: () => (
      <Grid
        gridAutoFlow="column"
        gridGap="1.8rem"
        justifyContent="start"
        alignItems="center"
        color="neutral.600"
      >
        <Button height="4.3rem" variant="primary" px="2rem">
          Publish
        </Button>
        <Box color="neutral.900" cursor="pointer">
          <MemoEyeShowIcon height="1.5rem" width="1.8rem" />
        </Box>
        <Box color="accents.100" cursor="pointer">
          <MemoDeleteIcon />
        </Box>
      </Grid>
    ),
  },
];

const Test = () => {
  const [isConfirm, setConfirm] = useState(true);
  const onSubmit = () => {};

  // const [visible, setVisible] = useState(false);
  // const handleSetVisible = () => {
  //   setVisible(true);
  // };
  // const hideModal = () => {
  //   setVisible(false);
  // };
  // const onUpload = (data) => {
  //   console.log("Upload files", data);
  // };
  // const onSelect = (data) => {
  //   console.log("Select files", data);
  // };
  // const onRemove = (id) => {
  //   console.log("Remove image id", id);
  // };
  return (
    <div>
      <Formik
        initialValues={{
          consultancy: "",
          firstname: "",
          lastname: "",
        }}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {() => {
          return (
            <Form>
              <Grid gRG="2rem">
                <FormSelect name="consultancy" options={[]} />
                <Grid gridTemplateColumns="1fr 1fr" gCG="2rem" gRG="2rem">
                  <FormInput
                    name="firstname"
                    type="firstname"
                    placeholder="First Name*"
                  />
                  <FormInput
                    name="lastname"
                    type="lastname"
                    placeholder="Last Name"
                  />
                  <FormInput name="email" type="text" placeholder="Email*" />

                  <Box>
                    <Text
                      fontSize={{ xs: "1.4rem", md: "1.8rem" }}
                      color="netural.800"
                      fontWeight="600"
                      mb="1.8rem"
                    >
                      Loan Amount (₹)
                    </Text>
                  </Box>
                </Grid>

                <FormSelect name="city" options={[]} disabled />
                <Button
                  type="submit"
                  variant="primary"
                  height={{ xs: "4.3rem", lg: "4.8rem" }}
                >
                  Consult
                </Button>
              </Grid>
            </Form>
          );
        }}
      </Formik>

      <Table
        tableHeader={columns.map(({ title, rightAligned, sortKey }) => ({
          name: title,
          rightAligned,
          sortKey,
          containerProps: {
            fontSize: "1.4rem",
            fontWeight: "600",
          },
        }))}
        borderColor="neutral.500"
      >
        <Box as="tbody" bg="white">
          {rolesData?.map((role) => (
            <tr key={role.id}>
              {columns.map((column, index) => (
                <td key={index}>
                  {column.render?.(role) ??
                    (column.field && role[column.field])}
                </td>
              ))}
            </tr>
          ))}
        </Box>
      </Table>
      <Flex>{/* <Filter /> */}</Flex>

      {/* <input type="file" /> */}
      <Box width="100vw" height="2rem" bg="green" />
      <FileUpload />

      {isConfirm === true && (
        <ConfirmationModal
          isOpen={isConfirm}
          onClose={() => setConfirm(false)}
          isPublish
          textOne="Are you sure you want to"
          textTwo="publish"
          textThree="the property SNN Raj Grandeur?"
        />
      )}
    </div>
  );
};

export default Test;
